import React, { Component } from 'react';
let imgbox = require('react-imagebox');
let ImageboxContainer = imgbox.ImageboxContainer;
let ImageboxModal = imgbox.ImageboxModal;
let ImageboxManager = imgbox.ImageboxManager;
let ImageboxPanel = imgbox.ImageboxPanel;

class PoiImagenes extends Component {
    shouldComponentUpdate = (nextProps) => {
        return this.props.imagenes !== nextProps.imagenes;
    };

    openImagebox = () => {
        const content = (
            <ImageboxModal>
                {
                    this.props.imagenes.map((imagen, i) => (
                            <ImageboxPanel title="Imagen" key={`imagen${i}`}>
                                <img data-src={imagen.url} alt={''}/>
                            </ImageboxPanel>
                        )
                    )
                }
            </ImageboxModal>
        );
        ImageboxManager.open({ content })
    };

    onClickTrigger = (index) => {
        const content = (
            <ImageboxModal>
                {
                    this.props.imagenes.map((imagen, i) => (
                            <ImageboxPanel title="Imagen" key={`imagen${i}`}>
                                <img data-src={imagen.url} alt={''}/>
                            </ImageboxPanel>
                        )
                    )
                }
            </ImageboxModal>
        );

        ImageboxManager.open({
            content,
            config: {
                titleBar: {
                    nextText: <a> Siguiente <span className="glyphicon glyphicon-triangle-right"/> </a>,
                    prevText: <a><span className="glyphicon glyphicon-triangle-left"/> Anterior</a>,
                    closeText: <a> Cerrar <span className="glyphicon glyphicon-remove"/></a>
                }
            },
            index
        })
    };

    render = () => {
        const { imagenes = [] } = this.props;

        const defaultConfig = {
            lightbox: {
                compatible: true,
                maxHeight: 800,
                maxWidth: 200,
                fadeMode: true
            }
        };

        const thumbnails = (
            <ul id="miniaturas" className="col-xs-12">
                {
                    imagenes.map((imagen, i) => (
                            <li className="col-md-4 col-xs-6" key={`imagen${i}`}
                                onClick={() => this.onClickTrigger(i)}>
                                <img src={imagen.thumbnail} alt={''}/>
                            </li>
                        )
                    )
                }
            </ul>
        )

        return (
            <div className="poi-imagenes-carrusel">
                {thumbnails}
                <div>
                    <ImageboxContainer {...defaultConfig} />
                </div>
            </div>
        )
    }
}

export default PoiImagenes;


// WEBPACK FOOTER //
// ./src/components/PoiImagenes.js